import React, { ComponentType } from "react";
import { TextAutoComplete } from "App/Atomics/AutoComplete";
import { findWorkList } from "./findWorkList";
import { components, OptionProps } from "react-select";
import { GRAY_5 } from "constants/baseColor";
import styled from "styled-components";
import { PRIMARY_COLOR_LIGHT } from "constants/color";

type Props = Pick<
  Parameters<typeof TextAutoComplete>[0],
  | "style"
  | "className"
  | "classNamePrefix"
  | "isDisabled"
  | "defaultValue"
  | "defaultOptions"
  | "onChange"
  | "onBlur"
  | "autoFocus"
  | "filterOption"
  | "placeholder"
> & { workClass?: "album" | "track" };

export const WorkTextAutoComplete = ({
  style,
  className,
  classNamePrefix,
  isDisabled,
  defaultValue,
  onChange,
  onBlur,
  autoFocus,
  filterOption,
  placeholder = "작품을 입력해주세요.",
  workClass
}: Props) => {
  return (
    <TextAutoComplete
      placeholder={placeholder}
      isDisabled={isDisabled}
      defaultValue={defaultValue}
      delay={200}
      style={style}
      className={className}
      classNamePrefix={classNamePrefix}
      filterOption={filterOption}
      onChange={onChange}
      onBlur={onBlur}
      autoFocus={autoFocus}
      loadInfoList={keyword => findWorkList(keyword, workClass)}
      components={{ Option }}
    />
  );
};

const Option: ComponentType<OptionProps<any>> = ({ children, ...props }) => {
  return (
    <components.Option {...props}>
      <OptionWrapper>
        <span className="id">{props.data.id}</span>
        <span>{children}</span>
        <span className="artist">{props.data.extra.artist}</span>
      </OptionWrapper>
    </components.Option>
  );
};

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  .id {
    font-size: 9px;
    color: ${GRAY_5};
  }
  .artist {
    font-size: 11px;
    color: ${PRIMARY_COLOR_LIGHT};
  }
`;
